import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  background-color: red;
  position: absolute;
  top: 10px;
  left: 10px;
  display: none;
  z-index: 50;
  color: white;
  background-color: var(--globe-red);
  border-radius: 2px;
  border: none;
  font-size: 0.875rem;
  letter-spacing: 0.25px;
  padding: 0.25rem 1rem;
  cursor: pointer;
  &:hover {
    background-color: var(--offblack)
  }
`;

const Button150 = ({ text, onClick }) => (
  <Button type="button" className="bentonsanscond-n4" onClick={() => onClick()}>{text}</Button>
);

export default Button150;

Button150.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Button150.defaultProps = {
  onClick: null,
};
